// source: friendemic/api/response/review_response_ticket.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var friendemic_api_response_tags_pb = require('../../../friendemic/api/response/tags_pb.js');
goog.object.extend(proto, friendemic_api_response_tags_pb);
var friendemic_api_response_types_pb = require('../../../friendemic/api/response/types_pb.js');
goog.object.extend(proto, friendemic_api_response_types_pb);
var friendemic_friendly_friendly_pb = require('../../../friendemic/friendly/friendly_pb.js');
goog.object.extend(proto, friendemic_friendly_friendly_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.friendemic.api.response.ReviewResponseTicket', null, global);
goog.exportSymbol('proto.friendemic.api.response.ReviewResponseTicket.CloseTicketReason', null, global);
goog.exportSymbol('proto.friendemic.api.response.ReviewResponseTicket.Status', null, global);
goog.exportSymbol('proto.friendemic.api.response.ReviewResponseTicket.Status.Type', null, global);
goog.exportSymbol('proto.friendemic.api.response.ReviewResponseTicketFilters', null, global);
goog.exportSymbol('proto.friendemic.api.response.ReviewResponseTicketFilters.Status', null, global);
goog.exportSymbol('proto.friendemic.api.response.ReviewResponseTicketFilters.SubmittedAt', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.friendemic.api.response.ReviewResponseTicket = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.friendemic.api.response.ReviewResponseTicket.repeatedFields_, null);
};
goog.inherits(proto.friendemic.api.response.ReviewResponseTicket, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.friendemic.api.response.ReviewResponseTicket.displayName = 'proto.friendemic.api.response.ReviewResponseTicket';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.friendemic.api.response.ReviewResponseTicket.Status = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.friendemic.api.response.ReviewResponseTicket.Status, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.friendemic.api.response.ReviewResponseTicket.Status.displayName = 'proto.friendemic.api.response.ReviewResponseTicket.Status';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.friendemic.api.response.ReviewResponseTicketFilters = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.friendemic.api.response.ReviewResponseTicketFilters, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.friendemic.api.response.ReviewResponseTicketFilters.displayName = 'proto.friendemic.api.response.ReviewResponseTicketFilters';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.friendemic.api.response.ReviewResponseTicket.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.toObject = function(opt_includeInstance) {
  return proto.friendemic.api.response.ReviewResponseTicket.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.friendemic.api.response.ReviewResponseTicket} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.friendemic.api.response.ReviewResponseTicket.toObject = function(includeInstance, msg) {
  var f, obj = {
    reviewUlid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    responseOrganizationUlid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    placeUlid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    channelType: jspb.Message.getFieldWithDefault(msg, 4, 0),
    reviewType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    ticketStatusType: jspb.Message.getFieldWithDefault(msg, 6, 0),
    tagsList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    rating: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
    assigneeUlid: (f = msg.getAssigneeUlid()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    submittedAt: (f = msg.getSubmittedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    deletedAt: (f = msg.getDeletedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    responseUlid: (f = msg.getResponseUlid()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    respondedAt: (f = msg.getRespondedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    canAutoPublish: jspb.Message.getBooleanFieldWithDefault(msg, 26, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.friendemic.api.response.ReviewResponseTicket}
 */
proto.friendemic.api.response.ReviewResponseTicket.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.friendemic.api.response.ReviewResponseTicket;
  return proto.friendemic.api.response.ReviewResponseTicket.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.friendemic.api.response.ReviewResponseTicket} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.friendemic.api.response.ReviewResponseTicket}
 */
proto.friendemic.api.response.ReviewResponseTicket.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReviewUlid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setResponseOrganizationUlid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlaceUlid(value);
      break;
    case 4:
      var value = /** @type {!proto.friendemic.api.response.ChannelType} */ (reader.readEnum());
      msg.setChannelType(value);
      break;
    case 5:
      var value = /** @type {!proto.friendemic.api.response.ReviewType} */ (reader.readEnum());
      msg.setReviewType(value);
      break;
    case 6:
      var value = /** @type {!proto.friendemic.api.response.ReviewResponseTicket.Status.Type} */ (reader.readEnum());
      msg.setTicketStatusType(value);
      break;
    case 7:
      var values = /** @type {!Array<!proto.friendemic.api.response.Tag>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addTags(values[i]);
      }
      break;
    case 8:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setRating(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAssigneeUlid(value);
      break;
    case 20:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSubmittedAt(value);
      break;
    case 21:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 22:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 23:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDeletedAt(value);
      break;
    case 24:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setResponseUlid(value);
      break;
    case 25:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setRespondedAt(value);
      break;
    case 26:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanAutoPublish(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.friendemic.api.response.ReviewResponseTicket.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.friendemic.api.response.ReviewResponseTicket} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.friendemic.api.response.ReviewResponseTicket.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReviewUlid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getResponseOrganizationUlid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPlaceUlid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getChannelType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getReviewType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getTicketStatusType();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      7,
      f
    );
  }
  f = message.getRating();
  if (f !== 0.0) {
    writer.writeFloat(
      8,
      f
    );
  }
  f = message.getAssigneeUlid();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSubmittedAt();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDeletedAt();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getResponseUlid();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getRespondedAt();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCanAutoPublish();
  if (f) {
    writer.writeBool(
      26,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.friendemic.api.response.ReviewResponseTicket.CloseTicketReason = {
  NO_RESPONSE: 0
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.friendemic.api.response.ReviewResponseTicket.Status.prototype.toObject = function(opt_includeInstance) {
  return proto.friendemic.api.response.ReviewResponseTicket.Status.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.friendemic.api.response.ReviewResponseTicket.Status} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.friendemic.api.response.ReviewResponseTicket.Status.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.friendemic.api.response.ReviewResponseTicket.Status}
 */
proto.friendemic.api.response.ReviewResponseTicket.Status.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.friendemic.api.response.ReviewResponseTicket.Status;
  return proto.friendemic.api.response.ReviewResponseTicket.Status.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.friendemic.api.response.ReviewResponseTicket.Status} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.friendemic.api.response.ReviewResponseTicket.Status}
 */
proto.friendemic.api.response.ReviewResponseTicket.Status.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.friendemic.api.response.ReviewResponseTicket.Status.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.friendemic.api.response.ReviewResponseTicket.Status.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.friendemic.api.response.ReviewResponseTicket.Status} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.friendemic.api.response.ReviewResponseTicket.Status.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.friendemic.api.response.ReviewResponseTicket.Status.Type = {
  UNKNOWN: 0,
  UNAVAILABLE: 1,
  REVIEW_UPDATED: 2,
  RESPONSE_SUBMITTED: 10,
  EDITS_REQUESTED: 11,
  APPROVED_PENDING_PUBLISH: 12,
  PUBLISHED: 30,
  COMPLETED: 31,
  COMPLETED_EXTERNAL: 32
};

/**
 * optional string review_ulid = 1;
 * @return {string}
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.getReviewUlid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.friendemic.api.response.ReviewResponseTicket} returns this
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.setReviewUlid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string response_organization_ulid = 2;
 * @return {string}
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.getResponseOrganizationUlid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.friendemic.api.response.ReviewResponseTicket} returns this
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.setResponseOrganizationUlid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string place_ulid = 3;
 * @return {string}
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.getPlaceUlid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.friendemic.api.response.ReviewResponseTicket} returns this
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.setPlaceUlid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional ChannelType channel_type = 4;
 * @return {!proto.friendemic.api.response.ChannelType}
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.getChannelType = function() {
  return /** @type {!proto.friendemic.api.response.ChannelType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.friendemic.api.response.ChannelType} value
 * @return {!proto.friendemic.api.response.ReviewResponseTicket} returns this
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.setChannelType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional ReviewType review_type = 5;
 * @return {!proto.friendemic.api.response.ReviewType}
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.getReviewType = function() {
  return /** @type {!proto.friendemic.api.response.ReviewType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.friendemic.api.response.ReviewType} value
 * @return {!proto.friendemic.api.response.ReviewResponseTicket} returns this
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.setReviewType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional Status.Type ticket_status_type = 6;
 * @return {!proto.friendemic.api.response.ReviewResponseTicket.Status.Type}
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.getTicketStatusType = function() {
  return /** @type {!proto.friendemic.api.response.ReviewResponseTicket.Status.Type} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.friendemic.api.response.ReviewResponseTicket.Status.Type} value
 * @return {!proto.friendemic.api.response.ReviewResponseTicket} returns this
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.setTicketStatusType = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * repeated Tag tags = 7;
 * @return {!Array<!proto.friendemic.api.response.Tag>}
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.getTagsList = function() {
  return /** @type {!Array<!proto.friendemic.api.response.Tag>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<!proto.friendemic.api.response.Tag>} value
 * @return {!proto.friendemic.api.response.ReviewResponseTicket} returns this
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.setTagsList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {!proto.friendemic.api.response.Tag} value
 * @param {number=} opt_index
 * @return {!proto.friendemic.api.response.ReviewResponseTicket} returns this
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.addTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.friendemic.api.response.ReviewResponseTicket} returns this
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};


/**
 * optional float rating = 8;
 * @return {number}
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.getRating = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.friendemic.api.response.ReviewResponseTicket} returns this
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.setRating = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional google.protobuf.StringValue assignee_ulid = 9;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.getAssigneeUlid = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 9));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.friendemic.api.response.ReviewResponseTicket} returns this
*/
proto.friendemic.api.response.ReviewResponseTicket.prototype.setAssigneeUlid = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.friendemic.api.response.ReviewResponseTicket} returns this
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.clearAssigneeUlid = function() {
  return this.setAssigneeUlid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.hasAssigneeUlid = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.Timestamp submitted_at = 20;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.getSubmittedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 20));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.friendemic.api.response.ReviewResponseTicket} returns this
*/
proto.friendemic.api.response.ReviewResponseTicket.prototype.setSubmittedAt = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.friendemic.api.response.ReviewResponseTicket} returns this
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.clearSubmittedAt = function() {
  return this.setSubmittedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.hasSubmittedAt = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional google.protobuf.Timestamp created_at = 21;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 21));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.friendemic.api.response.ReviewResponseTicket} returns this
*/
proto.friendemic.api.response.ReviewResponseTicket.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.friendemic.api.response.ReviewResponseTicket} returns this
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 22;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 22));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.friendemic.api.response.ReviewResponseTicket} returns this
*/
proto.friendemic.api.response.ReviewResponseTicket.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.friendemic.api.response.ReviewResponseTicket} returns this
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional google.protobuf.Timestamp deleted_at = 23;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.getDeletedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 23));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.friendemic.api.response.ReviewResponseTicket} returns this
*/
proto.friendemic.api.response.ReviewResponseTicket.prototype.setDeletedAt = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.friendemic.api.response.ReviewResponseTicket} returns this
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.clearDeletedAt = function() {
  return this.setDeletedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.hasDeletedAt = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional google.protobuf.StringValue response_ulid = 24;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.getResponseUlid = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 24));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.friendemic.api.response.ReviewResponseTicket} returns this
*/
proto.friendemic.api.response.ReviewResponseTicket.prototype.setResponseUlid = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.friendemic.api.response.ReviewResponseTicket} returns this
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.clearResponseUlid = function() {
  return this.setResponseUlid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.hasResponseUlid = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional google.protobuf.Timestamp responded_at = 25;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.getRespondedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 25));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.friendemic.api.response.ReviewResponseTicket} returns this
*/
proto.friendemic.api.response.ReviewResponseTicket.prototype.setRespondedAt = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.friendemic.api.response.ReviewResponseTicket} returns this
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.clearRespondedAt = function() {
  return this.setRespondedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.hasRespondedAt = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional bool can_auto_publish = 26;
 * @return {boolean}
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.getCanAutoPublish = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 26, false));
};


/**
 * @param {boolean} value
 * @return {!proto.friendemic.api.response.ReviewResponseTicket} returns this
 */
proto.friendemic.api.response.ReviewResponseTicket.prototype.setCanAutoPublish = function(value) {
  return jspb.Message.setProto3BooleanField(this, 26, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.friendemic.api.response.ReviewResponseTicketFilters.prototype.toObject = function(opt_includeInstance) {
  return proto.friendemic.api.response.ReviewResponseTicketFilters.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.friendemic.api.response.ReviewResponseTicketFilters} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.friendemic.api.response.ReviewResponseTicketFilters.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.friendemic.api.response.ReviewResponseTicketFilters}
 */
proto.friendemic.api.response.ReviewResponseTicketFilters.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.friendemic.api.response.ReviewResponseTicketFilters;
  return proto.friendemic.api.response.ReviewResponseTicketFilters.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.friendemic.api.response.ReviewResponseTicketFilters} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.friendemic.api.response.ReviewResponseTicketFilters}
 */
proto.friendemic.api.response.ReviewResponseTicketFilters.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.friendemic.api.response.ReviewResponseTicketFilters.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.friendemic.api.response.ReviewResponseTicketFilters.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.friendemic.api.response.ReviewResponseTicketFilters} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.friendemic.api.response.ReviewResponseTicketFilters.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.friendemic.api.response.ReviewResponseTicketFilters.Status = {
  UNKNOWN: 0,
  UPDATED: 5,
  PUBLISHED: 6,
  RESPONSE_SUBMITTED: 7,
  UNAVAILABLE: 8,
  COMPLETED: 9,
  COMPLETED_EXTERNAL: 10,
  APPROVED_PENDING_PUBLISH: 11,
  EDITS_REQUESTED: 12,
  NEW: 13
};

/**
 * @enum {number}
 */
proto.friendemic.api.response.ReviewResponseTicketFilters.SubmittedAt = {
  ZERO_TO_EIGHT_HOURS: 0,
  EIGHT_TO_SIXTEEN_HOURS: 1,
  SIXTEEN_TO_TWENTYFOUR_HOURS: 2,
  TWENTYFOUR_TO_FORTYEIGHT_HOURS: 4,
  TWO_TO_SEVEN_DAYS: 5,
  SEVEN_TO_THIRTY_DAYS: 6,
  THIRTY_TO_FORTYFIVE_DAYS: 7
};

goog.object.extend(exports, proto.friendemic.api.response);
